import React from "react";
import { Card, CardContent } from "@/components/ui/card";
const InfoCards: React.FC = () => {
  return <div className="mb-12">
      <Card className="border-heaven-gold/10">
        
      </Card>
    </div>;
};
export default InfoCards;